import { modals } from '@mantine/modals';
export function confirmDialog({ title, message, labels, }) {
    return new Promise((resolve) => {
        modals.openConfirmModal({
            title,
            children: message,
            labels,
            onCancel: () => resolve(false),
            onConfirm: () => resolve(true),
            centered: true,
            withCloseButton: true,
            closeOnClickOutside: true,
            // Ensure confirm modal stays above chat overlays/float layers
            zIndex: 12000,
        });
    });
}
